import React, {useState} from "react";
import Container from "react-bootstrap/Container";
import Header from "../../components/Header/Header";
import IndividualHeaderProposal from '../../components/IndividualHeaderPropose/IndividualHeaderProposal';
import IndividualProposalForm from "../../components/IndividualProposalForm/IndividualProposalForm.tsx";
import AboutProposalSection from '../../components/AboutProposalSection/AboutProposalSection';
import MakeProposalSection from '../../components/MakeProposalSection/MakeProposalSection';
import SubscribeFooter from '../../components/SubscribeFooter/SubscribeFooter';
import FooterMenu from '../../components/FooterMenu/FooterMenu';
// import './individualPropose.css';
import BurgerMenu from "../../components/BurgerMenu/burgerMenu";


function IndividualPropose() {
    const [openMenu, setOpenMenu] = useState(false);

    return (
        <div id="Home">
          <BurgerMenu right pageWrapId={"page-wrap"} outerContainerId={"Home"} isOpen={openMenu} onClose={() => setOpenMenu(false)}/>
          <div id="page-wrap">
            <div style={{ backgroundColor: '#F4004E', maxWidth: '100%' }}>
              <Container>
                <Header burgerMenuProp={setOpenMenu}/>
                <IndividualHeaderProposal/>
              </Container>
            </div>
            <div style={{ backgroundColor: '#F8F8F8', maxWidth: '100%' }}>
              <Container>
              <AboutProposalSection/>
              </Container>
            </div>
            <div style={{ backgroundColor: '#FCFCFC', maxWidth: '100%' }}>
              <Container>
              <IndividualProposalForm/>
              </Container>
            </div>
            <div style={{ backgroundColor: '#F3F3F3', maxWidth: '100%' }}>
              <Container>
              <MakeProposalSection />
              </Container>
            </div>
            <div style={{ backgroundColor: '#EDEEEF', maxWidth: '100%' }}>
              <Container>
                <SubscribeFooter />
              </Container>
            </div>
            <div style={{ backgroundColor: '#E2E4E5', maxWidth: '100%' }}>
              <Container>
                <FooterMenu />
              </Container>
            </div>
          </div>
        </div>
      );
}

export default IndividualPropose;